import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProductCreateView } from '@/features/products/products'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/products/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'product.create')) {
      throw redirect({ to: '/products' })
    }
  },
  component: ProductCreateView,
})
